<script lang="ts">
	import MenuIcon from "@lucide/svelte/icons/menu";
	import XIcon from "@lucide/svelte/icons/x";
	import { getRentalTemplateContext } from "./rental-template-context.svelte";

	const templateContext = getRentalTemplateContext()!;
	let isMenuOpen = $state(false);

	function toggleMenu() {
		isMenuOpen = !isMenuOpen;
	}

	const availabilityHref = $derived(
		templateContext.buildiumPropertyIds.length === 0 && templateContext.availabilityUrl
			? templateContext.availabilityUrl
			: "/#availability"
	);
	const availabilityExternal = $derived(availabilityHref.startsWith("http"));
	const showAvailability = $derived(
		templateContext.buildiumPropertyIds.length > 0 || !!templateContext.availabilityUrl
	);

	const residentsHref = $derived(
		templateContext.overrides?.residentPortalUrl ?? templateContext.tenantPortal
	);

	const navItems = $derived([
		{ name: "OVERVIEW", href: "/#overview", external: false },
		{ name: "PROPERTY DETAILS", href: "/#property-details", external: false },
		{ name: "PHOTOS", href: "/#photos", external: false },
		{ name: "FLOOR PLANS", href: "/#floor-plans", external: false },
		...(showAvailability
			? [{ name: "AVAILABILITY", href: availabilityHref, external: availabilityExternal }]
			: []),
		{ name: "CONTACT", href: "/#contact", external: false },
		{ name: "RESIDENTS", href: residentsHref, external: true }
	]);
</script>

<header class="fixed z-50 w-full bg-neutral-900 transition-all duration-200">
	<div class="container mx-auto px-4 py-4">
		<div class="flex items-center justify-between">
			<div class="text-2xl font-bold text-white">
				<a href="/">
					<img
						src={templateContext.logo}
						alt={templateContext.name}
						class="h-12 w-auto"
						width="300"
						height="48"
					/>
				</a>
			</div>

			<!-- Desktop Navigation -->
			<nav class="hidden md:block">
				<ul class="flex space-x-6">
					{#each navItems as { name, href, external }}
						<li>
							<a
								{href}
								target={external ? "_blank" : undefined}
								rel={external ? "noopener noreferrer" : undefined}
								class="text-sm text-white transition-colors duration-200 hover:text-amber-300"
							>
								{name}
							</a>
						</li>
					{/each}
				</ul>
			</nav>

			<!-- Mobile Menu Button -->
			<button class="text-white md:hidden" onclick={toggleMenu} aria-label="Toggle menu">
				{#if isMenuOpen}
					<XIcon class="h-6 w-6" />
				{:else}
					<MenuIcon class="h-6 w-6" />
				{/if}
			</button>
		</div>

		<!-- Mobile Navigation -->
		{#if isMenuOpen}
			<nav class="pt-4 pb-6 md:hidden">
				<ul class="space-y-4">
					{#each navItems as { name, href, external }}
						<li>
							<a
								{href}
								target={external ? "_blank" : undefined}
								rel={external ? "noopener noreferrer" : undefined}
								class="block text-white transition-colors duration-200 hover:text-amber-300"
								onclick={() => (isMenuOpen = false)}
							>
								{name}
							</a>
						</li>
					{/each}
				</ul>
			</nav>
		{/if}
	</div>
</header>
